module.exports = __webpack_public_path__ + "static/media/home.7899e21b.svg";